import React from 'react'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import moment from 'moment'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { formatNumberWithCommas } from '../../../../components/general/general-component/abstruct-component/FunctionRemoveCommas'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'

function AccountInfo({data}) {
    const { currency } = useSelectorCustom();
    const { translate } = AbstructLang()
    const { dispatch, langLocal, navigate } = AbstructVar()
    return (
        <div className='statment-expenses' dir={langLocal == "ar" ? "rtl" : "ltr"} >
            <div className='d-flex' style={{ justifyContent: "space-between" }} >
                <h3>{translate('account_info')}</h3>
            </div>
            <div className='top-statment-expenses'>
                <div className='one-top-statment-expenses'>
                    <span className='title-statment-expenses' >{translate('account_name')}</span>
                    <span className='sub-title-statment-expenses'>{data?.name}</span>
                </div>
                <div className='one-top-statment-expenses'>
                    <span className='title-statment-expenses'>{translate('account_type')}</span>
                    <span className='sub-title-statment-expenses'>{data?.account_type?.name}</span>
                </div>
                <div className='one-top-statment-expenses'>
                    <span className='title-statment-expenses'>{translate('created_by')}</span>
                    <span className='sub-title-statment-expenses'>{data?.created_by?.name}</span>
                </div>
                {/*<div className='one-top-statment-expenses'>
                    <span className='title-statment-expenses'>{translate('created_at')}</span>
                    <span className='sub-title-statment-expenses'>{moment(data?.created_at).format("YYYY-MM-DD")}</span>
                </div>*/}
                <div className='one-top-statment-expenses' /*style={{marginTop: "7px"}}*/>
                    <span className='title-statment-expenses'>{translate('amount')}</span>
                    <span className='sub-title-statment-expenses'>{ formatNumberWithCommas(parseInt(data?.amount)) } {' '} {translate(currency)}</span>
                </div>
            </div>
        </div>
    )
}

export default AccountInfo